module.exports = __webpack_public_path__ + "static/img/mypoints-bg.29a5479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/icon/mypoints-bg.png
// module id = 4TSD
// module chunks = 2